module.exports = __webpack_public_path__ + "static/img/stamp.32d0b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/stamp.jpg
// module id = Gl38
// module chunks = 1